import { render, staticRenderFns } from "./StudentCharge.vue?vue&type=template&id=4b41954a&scoped=true&lang=pug&"
import script from "./StudentCharge.vue?vue&type=script&lang=ts&"
export * from "./StudentCharge.vue?vue&type=script&lang=ts&"
import style0 from "./StudentCharge.vue?vue&type=style&index=0&id=4b41954a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b41954a",
  null
  
)

export default component.exports